// extracted by mini-css-extract-plugin
export default {"textSmall":"styles-module__textSmall__src-labstep-web-core-Text-Small-_mP7f8"};